/**
 * @generated SignedSource<<5533359b5a6f5372741e5aa9db9a1131>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PoliticalViewsMultiSelectInput_query$data = {
  readonly politicalViews: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
      readonly rowId: any;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "PoliticalViewsMultiSelectInput_query";
};
export type PoliticalViewsMultiSelectInput_query$key = {
  readonly " $data"?: PoliticalViewsMultiSelectInput_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PoliticalViewsMultiSelectInput_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PoliticalViewsMultiSelectInput_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SEQUENCE_ASC"
          ]
        }
      ],
      "concreteType": "PoliticalViewConnection",
      "kind": "LinkedField",
      "name": "politicalViews",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PoliticalView",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "politicalViews(orderBy:[\"SEQUENCE_ASC\"])"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "107bf564d80aa346195eb437ced6629a";

export default node;
